var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import * as React from "react";
import { ButtonModal, UserSearchField, } from "@atlassiansox/microscopekit";
import { ButtonGroup } from "@atlaskit/button";
var ModifyAZDRChampionForm = /** @class */ (function (_super) {
    __extends(ModifyAZDRChampionForm, _super);
    function ModifyAZDRChampionForm(props) {
        var _this = _super.call(this, props) || this;
        _this.saveChampions = function () { return __awaiter(_this, void 0, void 0, function () {
            var service;
            var _a, _b, _c, _d;
            return __generator(this, function (_e) {
                switch (_e.label) {
                    case 0:
                        service = this.props.data.service;
                        if (!(service.attributes.azdrAttribute && service.attributes.azdrAttribute.etag)) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.props.updateService({
                                variables: {
                                    service: service.id,
                                    etag: service.attributes.azdrAttribute.etag,
                                    dr1: (_a = this.state.primary) !== null && _a !== void 0 ? _a : "undefined",
                                    dr2: (_b = this.state.secondary) !== null && _b !== void 0 ? _b : "undefined"
                                }
                            })];
                    case 1:
                        _e.sent();
                        return [3 /*break*/, 4];
                    case 2: return [4 /*yield*/, this.props.updateService({
                            variables: {
                                service: service.id,
                                dr1: (_c = this.state.primary) !== null && _c !== void 0 ? _c : "undefined",
                                dr2: (_d = this.state.secondary) !== null && _d !== void 0 ? _d : "undefined"
                            }
                        })];
                    case 3:
                        _e.sent();
                        _e.label = 4;
                    case 4:
                        this.props.data.refetch();
                        return [2 /*return*/];
                }
            });
        }); };
        _this.state = {
            primary: props.primary,
            secondary: props.secondary
        };
        return _this;
    }
    ModifyAZDRChampionForm.prototype.render = function () {
        var _this = this;
        var AZDRButton = (React.createElement(ButtonGroup, null,
            React.createElement(ButtonModal, { buttonText: "Modify/Add DR Champions", heading: "Modify/Add DR Champions", actions: {
                    submit: {
                        text: "Save",
                        onSubmit: this.saveChampions
                    },
                    close: {
                        text: "Close"
                    }
                } },
                React.createElement(UserSearchField, { label: "Primary Champion", defaultUsers: [{ username: this.state.primary }], onChange: function (data) {
                        _this.setState({ primary: data[0] });
                    }, displayUserInfo: function (user) {
                        return (user.firstName || '') + " " + (user.lastName || '') + " " + (user.firstName || user.lastName ? '(' : '') + user.username + (user.firstName || user.lastName ? ')' : '');
                    } }),
                React.createElement(UserSearchField, { label: "Secondary Champion", defaultUsers: [{ username: this.state.secondary }], onChange: function (data) {
                        _this.setState({ secondary: data[0] });
                    }, displayUserInfo: function (user) {
                        return (user.firstName || '') + " " + (user.lastName || '') + " " + (user.firstName || user.lastName ? '(' : '') + user.username + (user.firstName || user.lastName ? ')' : '');
                    } }))));
        return (AZDRButton);
    };
    return ModifyAZDRChampionForm;
}(React.Component));
export { ModifyAZDRChampionForm };
